<template>

    <div class="advanced-search-modal">

        <div @click="closeAdvancedSearch" class="close-button">
            <i class="fas fa-times"></i>
        </div>

        <h1 style="width:100%;color:white;background-color: #d32f2f;padding:10px;margin:0px;">Recherche Avancée</h1>
        <input v-model="filter.denomSearch" class="form-control form-item" type="text" placeholder="Nom établissement"/>
        <div class="input-group form-item">
          <input v-model="filter.adresse" type="text" class="form-control" placeholder="Rue" style="width:65%"/>
          <input v-model="filter.codePostalEtablissement" type="text" class="form-control form-item" placeholder="Code Postal" style="width:35%"/>
        </div>
        <div class="form-item">
            <v-radio-group v-model="filter.nature" style="color:white">
                <v-radio label="Personne morale" value="PM"></v-radio>
                <v-radio label="Personne physique" value="PP"></v-radio>
            </v-radio-group>
            <div style="width:auto;">
                <v-checkbox v-model="filter.etablissementSiege" label="Siège Uniquement" value="true"></v-checkbox>
                <v-checkbox v-model="filter.etatAdministratifEtablissement" label="Actif Uniquement" value="A"></v-checkbox>
            </div>
        </div>
        <div class="form-item">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filter.dateCreationUniteLegale"
                label="Date de création (entreprise)"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter.dateCreationUniteLegale"
            ></v-date-picker>
          </v-menu>

          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filter.dateCreationEtablissement"
                label="Date de création (établissement)"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter.dateCreationEtablissement"
            ></v-date-picker>
          </v-menu>
        </div>
        <div class="form-item">
            <v-select
                    v-model="filter.categorieJuridiqueUniteLegaleLibelleNiv1"
                    :items="selectData.categoriesJuridiques"
                    item-text="categorieJuridiqueUniteLegaleLibelleNiv1"
                    label="Catégorie juridique"
                    dense
            ></v-select>
            </div>
            <div class="form-item">
            <v-select
                    v-model="filter.activitePrincipaleEtablissementLibelle"
                    :items="selectData.activiteNaf"
                    item-text="activitePrincipaleNaf1"
                    label="Activité principale"
                    dense
            ></v-select>
        </div>

        <input v-model="filter.identifiantAssociationUniteLegale" type="text" class="form-control form-item" placeholder="Identifiant Association" />

        <div class="form-end">
            <button
              @click="advancedSearch"
              type="button"
              class="btn"
            >
              <i class="fas fa-search"></i>
            </button>
            <button
              @click="resetAdvancedSearch"
              type="button"
              class="btn"
            >
              Reset
            </button>
        </div>
    </div>

</template>


<script>
import json from "./../../assets/select_activite_categorieJuridique.json"

export default {
  name: "AdvancedSearch",
  data() {
    return {
      defaultFilter: {
        denomSearch: "",
        adresse: "",
        codePostalEtablissement: "",
        nature: "",
        etablissementSiege: "",
        dateCreationUniteLegale: "",
        dateCreationEtablissement: "",
        activitePrincipaleUniteLegaleNiv1: "",
        activitePrincipaleEtablissementLibelle: "",
        identifiantAssociationUniteLegale: "",
        etatAdministratifUniteLegale: "",
        etatAdministratifEtablissement: "",
        categorieJuridiqueUniteLegaleLibelleNiv1: ""
      },
      filter: {},
      selectData: json,
    }
  },
  beforeMount() {
      if (this.filter == null)
          this.resetAdvancedSearch()
  },
  methods: {
    advancedSearch () {
      // Check first if payload is not empty
      if (!this.isAdvancedSearchEmpty()) {
          var newPath = "/find/"
          var oldPath = this.$router.currentRoute.fullPath
          if (newPath !== oldPath) {
              this.$router.push("/find/")
          }
        this.$store.dispatch('searchFindSiretFor', this.filter)
        this.$emit("closeSearchModal")
          this.$emit("search")
      }
    },
    isAdvancedSearchEmpty () {
        return JSON.stringify(this.filter) === JSON.stringify(this.defaultFilter)
    },
    resetAdvancedSearch () {
        this.filter = Object.assign({}, this.defaultFilter)
    },
    closeAdvancedSearch () {
        this.$emit("closeSearchModal")
    }
  }
}
</script>

<style>
.advanced-search-modal {
    z-index: 4;
    position:fixed;
    width: 50%;
    height: 550px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: 3px solid #d32f2f;
    box-shadow: 2px 2px 2px black;
    background-color: white;
    color: #d32f2f;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}
.advanced-search-modal h1 {
    font-size: 18pt;
}
.form-item {
    width: 95%;
    display:flex;
    flex-direction:row;
    flex-wrap: wrap;
    justify-content: space-around;
}
.close-button {
    color: white;
    font-size: 24pt;
    position: absolute;
    top: 0px;
    right: 15px;
    cursor: pointer;
}
.close-button:hover {
    opacity: 0.75;
}
.form-end{
    width: 100%;
    color: white;
    margin: 0px;
    display: flex;
    justify-content: space-around;
}
.form-end .btn {
    background-color: #d32f2f;
    font-weight: bold;
    width: 45%;
    border: 2px solid #d32f2f;
}
.form-end .btn:hover {
    background-color: white;
    color: #d32f2f;
}
</style>